import React from 'react'

const DesignToolsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='35'
    height='36'
    viewBox='0 0 35 36'
    fill='none'
    {...props}
  >
    <path
      d='M12.828 16.8379L15.9634 13.666L13.9217 11.5879L12.3176 13.192L10.2759 11.1504L11.8436 9.54618L10.203 7.90556L7.03111 11.0774L12.828 16.8379ZM24.7863 28.8326L27.9582 25.6608L26.3176 24.0201L24.7134 25.5879L22.6717 23.5462L24.2394 21.942L22.1613 19.9004L19.0259 23.0358L24.7863 28.8326ZM23.6561 10.2389L25.6978 12.2806L27.7394 10.2389L25.6613 8.16077L23.6561 10.2389ZM10.5676 31.4941H4.36965V25.2962L10.7499 18.916L2.91132 11.0774L10.203 3.78577L18.078 11.6608L23.5832 6.1191C23.8749 5.82743 24.203 5.60868 24.5676 5.46285C24.9322 5.31702 25.3089 5.2441 25.6978 5.2441C26.0867 5.2441 26.4634 5.31702 26.828 5.46285C27.1926 5.60868 27.5207 5.82743 27.8124 6.1191L29.7447 8.08785C30.0363 8.37952 30.2551 8.70764 30.4009 9.07223C30.5467 9.43681 30.6197 9.81355 30.6197 10.2024C30.6197 10.5913 30.5467 10.962 30.4009 11.3144C30.2551 11.6668 30.0363 11.9889 29.7447 12.2806L24.2394 17.8222L32.078 25.6608L24.7863 32.9524L16.9478 25.1139L10.5676 31.4941Z'
      fill='currentcolor'
    />
  </svg>
)

export default DesignToolsIcon
